import { Link } from 'react-router-dom';
function HomeAdmin({ allowedPages=[],fullName="n" }) { 
  const PAGE_MAP = {
  course_student_list: {
    path: "/coursestudentlist",
    label: "STUDENTS IN A COURSE"
  },
  process_convocation_request: {
    path: "/acceptconvocationrequest",
    label: "CONVOCATION CERTIFICATE REQUESTS"
  },
  print_convocation_certificate: {
    path: "/convocationcertificate",
    label: "CONVOCATION CERTIFICATES"
  },
  edit_student_profile: {
    path: "/editstudentname",
    label: "EDIT STUDENT NAME"
  },
  grade_computation: {
    path: "/gradeComputation",
    label: "GRADE COMPUTATION"
  },
  marks_entry: {
    path: "/marksEntry",
    label: "MARKS ENTRY"
  },
  master_course: {
    path: "/masterCourse",
    label: "MASTER COURSES"
  },
  merit_list: {
    path: "/meritlist",
    label: "MERIT LIST"
  },
  completion_list: {
    path: "/completionlist",
    label: "COMPLETION LIST"
  },
  print_provisonal_pass_certificate: {
    path: "/provisonalcertificate",
    label: "PROVISIONAL CERTIFICATE"
  },
  result_declaration: {
    path: "/resultdeclaration",
    label: "RESULT DECLARATION"
  },
  manage_submitted_grades: {
    path: "/submittedgradecourses",
    label: "SUBMITTED GRADES"
  },
  print_transcript: {
    path: "/runningtranscript",
    label: "RUNNING TRANSCRIPT"
  },
  manage_fourth_convocation_data: {
    path: "/fourthconvocationbulk",
    label: "4Th CONVOCATION"
  },
  view_student_history: {
    path: "/viewstudenthistory",
    label: "VIEW STUDENT HISTORY"
  },
  
};

const SUPERADMIN_MENU = [
   { path: "/manageuser", label: "MANAGE USER" },
  { path: "/masterCourse", label: "MASTER COURSES" },
  { path: "/editstudentname", label: "EDIT STUDENT NAME" },
  { path: "/coursestudentlist", label: "STUDENTS IN A COURSE" },
  { path: "/marksEntry", label: "MARKS ENTRY" },
  { path: "/gradeComputation", label: "GRADE COMPUTATION" },
  { path: "/submittedgradecourses", label: "SUBMITTED GRADES" },
  { path: "/resultdeclaration", label: "RESULT DECLARATION" },
   { path: "/meritlist", label: "MERIT LIST" },
   {  path: "/completionlist",    label: "COMPLETION LIST" },
   { path: "/runningtranscript", label: "RUNNING TRANSCRIPT" },
    { path: "/provisonalcertificate", label: "PROVISIONAL CERTIFICATE" },
 
  { path: "/acceptconvocationrequest", label: "CONVOCATION CERTIFICATE REQUESTS" },
   { path: "/convocationcertificate", label: "CONVOCATION CERTIFICATES" }  ,
    { path: "/fourthconvocationbulk", label: "4Th CONVOCATION" }  ,
     { path: "/viewstudenthistory", label: "VIEW STUDENT HISTORY" }  
];

   const links = new Set();
    allowedPages.forEach((e) => {
    if (e === "superadmin") {
  SUPERADMIN_MENU.forEach(item => links.add(item));
} else if (PAGE_MAP[e]) {
  links.add(PAGE_MAP[e]);
}
  });
  return (
    <main>   
    <div className="w-full border-b border-gray-200 flex flex-col text-center">
        <p className="text-xs sm:text-sm text-gray-400">Welcome</p>
        <p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-gray-400 mb-2">
          {fullName}
        </p>
      </div>
   <div className="flex flex-wrap gap-3 p-4 justify-center">
      {[...links].map((link, index) => (
          <Link key={index} to={link.path}>
            <div className="w-[150px] h-[150px] bg-gradient-to-r from-blue-400 to-blue-200 text-gray-800 p-2 rounded-lg shadow-lg hover:from-blue-700 hover:to-blue-400 hover:text-white transition-all cursor-pointer flex items-center justify-center text-center text-xs uppercase">
              {link.label}
            </div>
          </Link>
        ))}
    </div>
    
    </main>
    )
  }
  
  export default HomeAdmin